/**
 * MCP API Keys Service
 *
 * Provides functions for managing user MCP API keys for external tool access.
 */
import api from './api';

export interface MCPKey {
  id: string;
  name: string | null;
  description: string | null;
  organization_id: string;
  token_hint: string;
  is_active: boolean;
  scopes: string[];
  created_at: string;
  last_used_at: string | null;
  usage_count: number;
  expires_at: string | null;
}

export interface MCPKeyCreated extends MCPKey {
  api_key: string; // Only returned on creation!
}

export interface MCPKeyCreate {
  name?: string;
  description?: string;
  scopes?: string[];
  expires_in_days?: number;
}

/**
 * List all MCP API keys for the current user.
 */
export async function listMCPKeys(): Promise<MCPKey[]> {
  const response = await api.get('/settings/mcp-keys');
  return response.data;
}

/**
 * Create a new MCP API key.
 *
 * WARNING: The api_key is only returned once!
 */
export async function createMCPKey(data: MCPKeyCreate): Promise<MCPKeyCreated> {
  const response = await api.post('/settings/mcp-keys', data);
  return response.data;
}

/**
 * Revoke an MCP API key.
 */
export async function revokeMCPKey(keyId: string): Promise<void> {
  await api.delete(`/settings/mcp-keys/${keyId}`);
}
